module.exports = __webpack_public_path__ + "img/lg_ring_g_l_null_null.9f7e7e54.png";